import React, {useMemo, useState} from "react";
import {useIntl} from "react-intl";
import {useQuery} from "@tanstack/react-query";
import {useRestaurant} from "@/context/restaurant/RestaurantProvider";
import {Table, TableData} from "peggirkit";
import {LoyaltyRewardDetails} from "@/data/entities/loyaltyReward";
import DeleteLoyaltyRewardModal, {
    DeleteLoyaltyRewardState
} from "@widgets/loyaltyRewards/delete/DeleteLoyaltyRewardModal";
import {getLoyaltyRewardsTableColumns} from "@widgets/loyaltyRewards/overview/table/LoyaltyRewardsTableColumns";
import UpdateOrdering from "@widgets/featuredProducts/overview/ordering/UpdateOrdering";
import {api} from "@/data/api";


const LoyaltyRewardsTable = () => {
    const intl = useIntl();
    const {dashboardLocation} = useRestaurant();
    const [deleteModal, setDeleteModal] = useState<DeleteLoyaltyRewardState>({
        showModal: false,
        loyaltyRewardId: -1,
    });
    const [tableData, setTableData] = useState<TableData<LoyaltyRewardDetails>[]>([]);
    const {isFetching} = useQuery({
        queryKey: ["loyalty-rewards", dashboardLocation.id],
        queryFn: async () => {
            const result: LoyaltyRewardDetails[] = await api.loyaltyReward.listLoyaltyRewards(dashboardLocation.id);
            setTableData(result);
            return result;
        },
    });
    const columns = useMemo(
        () => getLoyaltyRewardsTableColumns(intl, setDeleteModal),
        [intl, setDeleteModal]);

    return (
        <div className={"flex flex-col gap-4"}>
            <Table<LoyaltyRewardDetails>
                columns={columns}
                data={tableData}
                setData={setTableData}
                loading={isFetching}
                loadingConfig={{
                    skeletonRepeat: 4,
                }}
                rowConfig={{
                    draggableRows: {
                        onDragEnd: ({swapRows}) => {
                            swapRows();
                        },
                    },
                }}
            />

            <UpdateOrdering<LoyaltyRewardDetails>
                isUpdatingOverview={isFetching}
                persistFn={api.loyaltyReward.updateLoyaltyRewardsOrdering}
                tableData={tableData}
            />

            <DeleteLoyaltyRewardModal
                show={deleteModal.showModal}
                setShow={(show: boolean) => setDeleteModal(prev => ({...prev, showModal: show}))}
                loyaltyRewardId={deleteModal.loyaltyRewardId}
                cb={(remainingFeaturedProducts: LoyaltyRewardDetails[]) => {
                    setTableData(remainingFeaturedProducts);
                }}
            />
        </div>
    );
};

export default LoyaltyRewardsTable;